import { AxiosResponse } from 'axios';
import apiClient from '../axios';
import {
  IGetResourceCollectionResponse,
  IGetResourceResponse,
} from '../interfaces';
import {
  IUpdateWeaponGroupDefinitionParams,
  WeaponGroupDefinition,
} from './interfaces';

export const getPortalWeaponGroups = async (): Promise<WeaponGroupDefinition[]> => {
  const response: AxiosResponse<
    IGetResourceCollectionResponse<WeaponGroupDefinition>
  > = await apiClient.get('/association/weapon-groups');

  return response.data.data;
};

export const getManageWeaponGroups = async (): Promise<WeaponGroupDefinition[]> => {
  const response: AxiosResponse<
    IGetResourceCollectionResponse<WeaponGroupDefinition>
  > = await apiClient.get('/manage/association/weapon-groups');

  return response.data.data;
};

export const updateManageWeaponGroup = async (
  id: number,
  params: IUpdateWeaponGroupDefinitionParams
): Promise<WeaponGroupDefinition> => {
  const response: AxiosResponse<IGetResourceResponse<WeaponGroupDefinition>> =
    await apiClient.put(`/manage/association/weapon-groups/${id}`, params);

  return response.data.data;
};
